<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Modification du courrier</div>
        <div class="modal-body"
            [ngClass]="{ 'retenue': courrierForm?.get('retenueEnvoiDmp')?.value === true, 'retenue-annule-et-remplace': courrierForm?.get('retenueEnvoiDmp')?.value === true && courrierToEdit, 'annule-et-remplace': courrierForm?.get('retenueEnvoiDmp')?.value === false && courrierToEdit }">
            <form [formGroup]="courrierForm" (ngSubmit)="saveCourrier()" *ngIf="courrierForm"
                class="courrier-card-content">
                <div class="input-edit-mode-container">
                    <frg-form-input label="Titre du courrier" class="input-edit-mode-title" id="titre" type="text"
                        [formGroup]="courrierForm" [control]="courrierForm.get('titre')">
                    </frg-form-input>
                    <frg-form-input class="input-edit-mode" id="typeDocument" label="Type de document" type="ngSelect"
                        closeOnSelect="true" [selectValue]="courrierTypesDocuments" [formGroup]="courrierForm"
                        [control]="courrierForm.get('typeDocument')"  [required]="courrierForm?.get('retenueEnvoiDmp')?.value === false || (courrierForm?.get('retenueEnvoiDmp')?.value === false && courrierToEdit)">
                    </frg-form-input>
                    <frg-form-input class="edit-mode-checkbox" *ngIf="courrierToEdit" label="Annule et remplace"
                        id="annuleEtRemplace" type="checkbox" [formGroup]="courrierForm"
                        [control]="courrierForm.get('annuleEtRemplace')" [isCheckLabelAlign]="true">
                    </frg-form-input>
                </div>
                <div class="col-container">
                    <div class="col col-1">
                        <div class="buttons-froala">
                            <div class="icon-button ald" title="Ajout de texte en rapport avec ALD"
                                (mousedown)="addAld()">ALD
                            </div>
                            <div class="icon-button correspondant" title="Ajouter un pavé correspondant"
                                (mousedown)="addCorrespondant()">
                            </div>

                            <frg-button (activated)="rechercheSemantique()">Référentiels sémantiques</frg-button>
                            <div class="icon-button piece-jointe" title="Ajouter une pièce jointe"
                                (mousedown)="addPieceJointe()">
                            </div>
                            <p class="addedCorrespondants" *ngIf="selectBodyTable.objects.length > 0">Vous avez ajouté {{ selectBodyTable.objects.length }} correspondant(s)</p>
                        </div>
                        
                        <froala-editor class="froala-editor" [froalaEditor]="editorOptions" [(froalaModel)]="editorContent"
                            (froalaInit)="initialize($event)" cdkDropList (cdkDropListDropped)="dropped($event)" id="froalaDrop" #froalaDrop
                            cdkDropListConnectedTo="table2" placeholder="Ajouter du texte ici..."></froala-editor>
                        
                        <div class="retenue-pj-container">
                        <div class="retenu-wrapper" [ngClass]="{ 'retenue': courrierForm?.get('retenueEnvoiDmp')?.value === true }">
                            <frg-form-input label="Retenir l'envoi (pas d'envoi automatique au DMP du patient)"
                                id="retenueEnvoiDmp" type="checkbox" [formGroup]="courrierForm"
                                [control]="courrierForm.get('retenueEnvoiDmp')" [isCheckLabelAlign]="true" class="input">
                            </frg-form-input>
                            <frg-form-input *ngIf="courrierForm?.get('retenueEnvoiDmp')?.value === true"
                                label="Motif de la retenue" id="motifRetenueEnvoiDmp" type="textarea"
                                [formGroup]="courrierForm" [control]="courrierForm.get('motifRetenueEnvoiDmp')"
                                [isCheckLabelAlign]="false" class="input">
                            </frg-form-input>
                        </div>
                        <!-- Section des pièces jointes manuelles -->
                        <div class="manual-attachments-section" *ngIf="manualAttachments.length > 0">
                            <div class="attachments-header">
                                <mat-icon>attach_file</mat-icon>
                                <mat-checkbox [(ngModel)]="saveAttachmentsWithCourrier" 
                                              [ngModelOptions]="{standalone: true}"
                                              (change)="onSaveAttachmentsToggle($event)"
                                              class="save-attachments-checkbox">
                                    Sauvegarder les PJ avec le courrier
                                </mat-checkbox>
                                <span class="attachments-count" *ngIf="!saveAttachmentsWithCourrier">Pièces jointes ({{ manualAttachments.length }})</span>
                            </div>
                        
                            <div class="attachments-list" *ngIf="!saveAttachmentsWithCourrier">
                                <div class="attachment-item" *ngFor="let attachment of manualAttachments">
                                    <mat-icon class="file-icon">insert_drive_file</mat-icon>
                                    <span class="attachment-name" 
                                          [class.clickable]="isAttachmentPreviewable(attachment)"
                                          (click)="previewManualAttachment(attachment)"
                                          title="{{ attachment.title }}">{{ attachment.title }}</span>
                                    <span class="attachment-size" *ngIf="attachment.size">({{ formatFileSize(attachment.size) }})</span>
                                    <mat-icon class="download-icon" 
                                              *ngIf="!isAttachmentPreviewable(attachment)"
                                              (click)="downloadManualAttachment(attachment)"
                                              title="Télécharger ce fichier">
                                        download
                                    </mat-icon>
                                    <mat-icon class="delete-icon" (click)="removeManualAttachment(attachment.id)"
                                        title="Supprimer cette pièce jointe">
                                        delete
                                    </mat-icon>
                                </div>
                            </div>
                        </div>
                        </div> 
                    </div>
                    <div class="col col-2">
                        <div class="col2-top">
                            <div class="buttons-table">
                                <div [ngClass]="{'active': isTag === true}" class="icon-button tag" title="Tags"
                                    (mousedown)="changeTable('tag')"></div>
                                <div [ngClass]="{'active': isGlossaire === true }" class="icon-button glossaire"
                                    title="Glossaire" (mousedown)="changeTable('glossaire')">
                                </div>
                                <div [ngClass]="{'active': isPenseBete === true}" class="icon-button pense-bete"
                                    title="Pense-bête" (mousedown)="changeTable('penseBete')"></div>
                                <div [ngClass]="{'active': isMaquette === true}" class="icon-button maquette"
                                    title="Maquettes" (mousedown)="changeTable('maquette')">
                                </div>
                                <div [ngClass]="{'active': isCriteres === true}" class="icon-button critere"
                                    title="Critères" (mousedown)="changeTable('critere')">
                                </div>
                                <div [ngClass]="{'active': isDossierPatient === true}"
                                    class="icon-button element-dossier-patient" title="Dossier patient"
                                    (mousedown)="changeTable('dossierPatient')"></div>
                                <div [ngClass]="{'active': isCourrierPerso === true}"
                                    class="icon-button liste-courrier-type" title="Courriers personnalisés"
                                    (mousedown)="changeTable('courrierPerso')"></div>
                                <div [ngClass]="{'active': isMedicamentLibre === true}"
                                    class="icon-button medicaments-saisie-libre" title="Médicaments saisie libre"
                                    (mousedown)="changeTable('medicamentLibre')"></div>
                            </div>
                            <frg-search-input class="courrier-search-input" #searchInput (search)="filterAutoreplaceList($event)"></frg-search-input>
                            <frg-table #table2 [keysBody]="autoReplaceBodyTable" [keysColumn]="autoReplaceColumnTable"
                                class="table" [dragDrop]="true" idDropTable="table2" idConnectedTable="froalaDrop">
                            </frg-table>                                                     
                        </div>
                       
                        <div class="col2-bottom">
                            <div   class="checkbox-container">
                                <div class="checkbox-col1">
                                    <frg-form-input
                                    id="isVilleDate"
                                    label="Ville et date"
                                    type="checkbox"
                                    isCheckLabelAlign="true"
                                    [formGroup]="courrierForm"
                                    [control]="courrierForm.get('isVilleDate')"
                                ></frg-form-input>
                                    <frg-form-input
                                    id="isNomPatient"
                                    label="Nom du patient"
                                    type="checkbox"
                                    isCheckLabelAlign="true"
                                    [formGroup]="courrierForm"
                                    [control]="courrierForm.get('isNomPatient')"
                                ></frg-form-input>
                                    <frg-form-input
                                    id="isEnteteVide"
                                    label="En-tête vide"
                                    type="checkbox"
                                    isCheckLabelAlign="true"
                                    [formGroup]="courrierForm"
                                    [control]="courrierForm.get('isEnteteVide')"
                                ></frg-form-input>
                                </div>
                                <div class="checkbox-col2">
                                    <frg-form-input
                                    id="isPiedVide"
                                    label="Pied de page vide"
                                    type="checkbox"
                                    isCheckLabelAlign="true"
                                    [formGroup]="courrierForm"
                                    [control]="courrierForm.get('isPiedVide')"
                                ></frg-form-input>
                                    <frg-form-input
                                    id="isImpressionPatient"
                                    label="Duplicata patient"
                                    type="checkbox"
                                    isCheckLabelAlign="true"
                                    [formGroup]="courrierForm"
                                    [control]="courrierForm.get('isImpressionPatient')"
                                ></frg-form-input>
                                    <frg-form-input
                                    id="isDuplicata"
                                    label="Duplicata"
                                    type="checkbox"
                                    isCheckLabelAlign="true"
                                    [formGroup]="courrierForm"
                                    [control]="courrierForm.get('isDuplicata')"
                                ></frg-form-input>
                                </div>
                            </div>

                            <div class="bottom-buttons">            
                                    <frg-button class="icon-buttons" id="subButton" (activated)="saveCourrier(true)" [type]="'button'"
                                        [disabled]="!courrierForm.valid" [title]="'Enregistrer le courrier'">
                                        <mat-icon>save</mat-icon>
                                    </frg-button>
                                    <!-- <frg-button (mousedown)="previewCourrier()" [type]="'button'" [disabled]="!courrierForm.valid">Imprimer
                                    </frg-button> -->
                                    <frg-button class="icon-buttons"  (activated)="saveThenSendMail()" [type]="'button'" [disabled]="!courrierForm.valid || !autorisationEnvoiMail" [title]="'Envoyer par mail'">
                                        <mat-icon>email</mat-icon>
                                    </frg-button>
                               
                               
                                    <frg-button class="icon-buttons" (activated)="saveThenPrint()" [type]="'button'" [disabled]="!courrierForm.valid" [title]="'Enregistrer et imprimer le courrier'">
                                       <mat-icon>print</mat-icon>
                                    </frg-button>
                                    <frg-button class="icon-buttons" [type]="'reset'" (activated)="closeAddEditModal()"
                                        [backgroundColor]="'var(--darkest-primary)'" [title]="'Annuler'">
                                        <mat-icon>close</mat-icon>
                                    </frg-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
    <div class="modal-background"></div>
